import React from 'react';
import './CourseSpecial.less';

/**
 * 可选参数
 */
interface IProps {
	list: any[];
	type: 'QA' | 'special';
}

/**
 * 页眉
 */
class CourseSpecial extends React.PureComponent<IProps, any> {
	/**
	 * 拼接跳转地址
	 * @param id 文章id
	 */
	public joinLink(id: string): string {
		if (this.props.type === 'QA') {
			return `https://m.qlchat.com/hot/html/${id}.html`;
		} else {
			return `https://m.qlchat.com/hot/t/${id}/`;
		}
	}

	/**
	 * render
	 */
	public render(): any {
		return this.props.list && this.props.list.length > 0 ? (
			<div className="p-course-special">
				{this.props.list.map((item: any, idx: number): any => (
					<a key={idx} href={this.joinLink(item.id)} className="elli-text" title={item.title}>
						{item.title}
					</a>
				))}
			</div>
		) : null;
	}
}

export default CourseSpecial;
